<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header='getHeader()' @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-norwegian');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u00e6 \u00f8 \u00e5 \u00e0 \u00ea \u00e9 \u00f4 \u00f2 \u00f3',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
